import { render, staticRenderFns } from "./MagazineAdditionalContent.vue?vue&type=template&id=771a7768&scoped=true&"
import script from "./MagazineAdditionalContent.vue?vue&type=script&lang=js&"
export * from "./MagazineAdditionalContent.vue?vue&type=script&lang=js&"
import style0 from "./MagazineAdditionalContent.vue?vue&type=style&index=0&id=771a7768&scoped=true&lang=css&"
import style1 from "./MagazineAdditionalContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a7768",
  null
  
)

export default component.exports